/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsBulkOperationsRestoreFromArchiveDesktopRequest,
  TChatsBulkOperationsRestoreFromArchiveDesktopModel,
  IMappers,
  TChatsBulkOperationsRestoreFromArchiveDesktopResponse,
  TChatsBulkOperationsRestoreFromArchiveDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createChatsBulkOperationsRestoreFromArchiveDesktopModel(
  parameters: TChatsBulkOperationsRestoreFromArchiveDesktopRequest,
): TChatsBulkOperationsRestoreFromArchiveDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/bulk-operations/restore-from-archive-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsBulkOperationsRestoreFromArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsBulkOperationsRestoreFromArchiveDesktopRequest;
}

export async function fetchChatsBulkOperationsRestoreFromArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsBulkOperationsRestoreFromArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsBulkOperationsRestoreFromArchiveDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsBulkOperationsRestoreFromArchiveDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsBulkOperationsRestoreFromArchiveDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsBulkOperationsRestoreFromArchiveDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsBulkOperationsRestoreFromArchiveDesktopResponse>;
}
